export const ValidationError = {
  Required: 'Поле обязательно'
} as const
